import { FormConfig } from 'components/common/form/FormConfig';
import { useMemo } from 'react';
import { renderBidPriceFieldArray } from './BidPriceSettings';
import i18n from 'i18n';
import { FormContent } from 'components/common/form/Form';

export const ChannelGroupBidPriceForm: React.FC = () => {
  const bidPriceFormConfig = useMemo(() => {
    return new FormConfig.Builder()
      .addSection(
        new FormConfig.SectionBuilder(
          new FormConfig.FieldsBuilder()
            .addFormikCustom({
              label: '',
              name: 'property.addonProps.campaignBidPrice',
              render: renderBidPriceFieldArray
            })
            .build()
        )
          .withTitle(i18n.t('channelGroups.titles.bidPriceContent'))
          .build()
      )
      .build();
  }, []);

  return <FormContent formConfig={bidPriceFormConfig} />;
};
